import NetworkError from '../NetworkError';
class Timeout extends NetworkError {
    constructor(options) {
        super('Timeout', options);
    }
}
export default Timeout;
